module.exports = __webpack_public_path__ + "img/encryption-lock-icon.svg";